import { Location } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TcApiError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-api-error';
import { TcErrorType } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-error';
import { TcHttpError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-http-error';
import { LEVEL } from '@tc-core/model/it/codegen/ui/framework/dialog-model';
import { ModalData } from '@tc-core/model/it/codegen/ui/framework/modal-data';
import { ERROR_LEVEL, PageSection } from '@tc-core/model/it/codegen/ui/framework/page-section';
import { SummaryCardData } from '@tc-core/model/it/codegen/ui/framework/summary-card-data';
import { TC } from '@tc-core/util/constants';
import { EventManager } from '@tc-core/util/framework/event-manager.service';
import { FocusViewManager } from '@tc-core/util/framework/focus-view-manager.service';
import { UserJourneyManager } from '@tc-core/util/framework/user-journey-manager.service';
import { CommonHelper } from '@tc-core/util/helpers/common-helper.service';
import { SpinnerService } from '@tc-core/util/ui/spinner.service';
import { DialogService } from '@tc/dialog/dialog.service';
import { ModalService } from '@tc/modal/modal.service';
import { UserProfile } from 'app/models/user/user-profile';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { TCO } from '../../../constants';
import {
    CityChange,
    CountryChange,
    CountryStateCityWrapper,
    InitialCountryStateCityCodes,
    StateChange
} from '../../../models/common/country-state-city-wrapper';
import { City, Country, State } from '../../../models/common/locale';
import { PaymentInfo } from '../../../models/common/payment-info';
import { GenericSearchCriteria } from '../../../models/criteria/generic-search-criteria';
import { SupplierSearchCriteria } from '../../../models/criteria/supplier-search-criteria';
import { UserProfileSearchCriteria } from '../../../models/criteria/user-profile-search-criteria';
import { GenericTypePathname } from '../../../models/helper/generic-type-pathname';
import { PageType } from '../../../models/helper/page-type';
import { ContactDetails } from '../../../models/profile/contact-details';
import { ResourceType } from '../../../models/reservation/assignment';
import { GenericResource } from '../../../models/resource/generic-resource';
import { PersonalInformation } from '../../../models/resource/personal-information';
import { Resource } from '../../../models/resource/resource';
import { ResourceSpecificData } from '../../../models/resource/resource-specific-data';
import { SupplierSummary } from '../../../models/summary/supplier-summary';
import { ChangeDetectSupporter } from '../../../models/supplier/change-detect-supporter';
import {
    DataHandlerService
} from '../../../services/backend-consumers/master-data-handler-service/data-handler.service';
import {
    ProfileManagementService
} from '../../../services/backend-consumers/supplier-service/profile-management.service';
import { SupplierService } from '../../../services/backend-consumers/supplier-service/supplier.service';
import { UserProfileService } from '../../../services/backend-consumers/user-service/user-profile.service';
import {
    CountryStateCityService
} from '../../../services/business-utils/country-state-city/country-state-city.service';
import { ChangeDetectorService } from '../../../services/util/change-detector/change-detector.service';
import { DMCCommon } from '../../../services/util/common/dmc-common';
import { RootService } from '../../../services/util/core-services/root.service';
import { DataKey, DataStoreService } from '../../../services/util/framework/data-store.service';
import { DMCQueryParamsService } from '../../../services/util/framework/dmc-query-params.service';
import { ResponseUtil } from '../../../services/util/response/response-util.service';
import { DMCLocalStorageService, LocalDataKey } from '../../../services/util/system/dmc-local-storage.service';
import { CardDataHandlerService } from '../../../services/util/ui/card-data-handler-service.service';
import { AdditionalContactsComponent } from '../../../widgets/shared/additional-contacts/additional-contacts.component';
import { TaxSchemesComponent } from '../../../widgets/shared/tax-schemes/tax-schemes.component';
import {
    ManageSupplierAttributesWrapperComponent
} from '../manage-supplier-attributes-wrapper/manage-supplier-attributes-wrapper.component';
import { AddNoteComponent } from '../shared/add-note/add-note.component';
import { CommonDataSearchCriteria } from '../../../models/criteria/common-data-search-criteria';
import { CommonDataType } from '../../../models/reservation-v2/common-data-type';

@Component({
    selector: 'tc-generic',
    templateUrl: './generic.component.html'
})
export class GenericComponent implements OnInit, OnDestroy, AfterViewInit {

    pageType = '';

    // type of form generated
    genericTypePathName: string;

    // data model
    resource: Resource;
    resourceUnedited: Resource;

    // data collection
    personalInfo: PersonalInformation;
    contactDetails: ContactDetails;
    additionalContactDetails: ContactDetails[];
    resourceSpecificData: ResourceSpecificData;

    // supportive data
    // contacts

    // country state city
    countryStateCityChangeMap: Map<number, CountryStateCityWrapper> = new Map();
    cityList: City[] = [];
    stateList: State[] = [];
    countryList: Country[] = [];
    // --country state city--//

    titles: any[] = [];
    categories: any[] = [];
    defaultContactCategory: any;

    supplierTypes: any[] = [];

    // additional contacts
    additionalContactSummary: SummaryCardData = new SummaryCardData();
    CARD_CONFIG_ADDITIONAL_CONTACT = 'additionalContact';
    additionalContactContents: SummaryCardData[] = [];

    // payment info
    currencyList: any[] = [];
    payMethods: any[] = [];

    // subscriptions
    attributesSubscription: Subscription = new Subscription();

    // tax scheme
    CARD_CONFIG_TAXSCHEME = 'taxScheme';
    taxSchemeSummary: SummaryCardData;
    taxSchemeContents: SummaryCardData[] = [];
    taxSchemes: any[] = [];

    isResourceTypeReadOnly: boolean = false;
    resourceTypes: any[] = [];
    RESOURCE_CATEGORY = 'generic';
    resourceTypeObj: any;
    resourceType = '';
    selectedResTypes = [];
    userProfile: UserProfile;

    assignedSupplierForResource: SupplierSummary;
    filteredSuppliers: SupplierSummary[] = [];
    filteredUsers: UserProfile[] = [];
    // -- supportive data --//

    // validations
    dataChanged = false;
    formSaved = false;
    isSaveEnable = false;
    personalInfoValid = false;
    personalContactValid = false;
    keyControlInformationValid = false;
    additionalContactsValid = true;
    supplierPaymentValid = false;
    hasValidSupplier = false;

    // specific form validations
    changeDetectSupporter = new ChangeDetectSupporter(); // this will set to true if there is specific form

    driverValid = false;
    guideValid = false;
    repValid = false;
    mealValid = false;
    bellyDancerValid = false;
    tanouraValid = false;
    hennaArtistValid = false;
    ticketValid = false;
    specificDataValid = false;
    disableKeyControlEdit = false;
    private missingCostForSupplier: boolean = false;

    private createResourceObsv: Subscription = new Subscription();
    private updateResourceObsv: Subscription = new Subscription();
    private modalCloseSubscription: Subscription = new Subscription();

    // -- specific form validations --//

    // page section
    private pageSectionsMap: Map<string, PageSection>;
    public personalInfoSection: PageSection;
    public keyControlSection: PageSection;
    public contactDetailsSection: PageSection;
    public specificFormSection: PageSection;
    public paymentInfoSection: PageSection;
    public additionalContactsSection: PageSection;
    public supplierAttributesSection: PageSection;
    public notesSection: PageSection;
    public taxSchemeSection: PageSection;
    private CARD_CONFIG_GENERIC_EDIT = 'generic_resource_edit';
    private headerTextNew: string = 'New Generic Profile';
    private headerTextEdit: string = 'Edit Generic Profile';

    // -- page section --//

    @ViewChild(AdditionalContactsComponent) additionalContactComponent: AdditionalContactsComponent;
    @ViewChild(TaxSchemesComponent) taxSchemeComponent: TaxSchemesComponent;

    constructor(
        private activatedRoute: ActivatedRoute,
        private dataHandlerService: DataHandlerService,
        private userJourneyManager: UserJourneyManager,
        private location: Location,
        private focusViewManager: FocusViewManager,
        private modalService: ModalService,
        private cardDataHandlerService: CardDataHandlerService,
        private dataStore: DataStoreService,
        private profileManagementService: ProfileManagementService,
        private em: EventManager,
        private dialogService: DialogService,
        private supplierService: SupplierService,
        private userProfileService: UserProfileService,
        private route: ActivatedRoute,
        private countryStateCityService: CountryStateCityService,
        private spinnerService: SpinnerService,
        private common: DMCCommon,
        private commonHelper: CommonHelper,
        private rootService: RootService,
        private queryParamService: DMCQueryParamsService,
        private changeDetectorService: ChangeDetectorService,
        private localStorage: DMCLocalStorageService
    ) {
    }

    ngOnInit() {

        this.pageType = this.route.snapshot.queryParamMap.get('page').split('_')[0];

        this.setGenericType();

        this.retrieveMasterData();
        // this.generateMaps();

        // data subscriptions
        this.getSupplierAttributes();
        // country state city
        this.subscribeCountryStateCityListChange();
        // --country state city--//
        this.getUserDetails();

        // data model initiation
        this.initDataModel();

        if (this.pageType === PageType.CREATE) {
            this.dataStore.get(DataKey.selectedGenericResourceForEditAsNew, true)
                .pipe(take(1))
                .subscribe(data => {
                    if (data != null) {
                        this.dataStore.set(DataKey.selectedGenericResourceForEditAsNew, null, true);

                        this.fillResourceObject(data);
                    } else {
                        let data: Resource = this.localStorage.load<Resource>(LocalDataKey.unSavedSupplier);
                        if (data && !data.resourceId) {
                            this.fillResourceObject(data);
                        }
                    }
                    this.initPageSectionReferences();
                });
        } else if (this.pageType === PageType.EDIT) {
            this.dataStore.get(DataKey.selectedGenericResourceForEdit, true)
                .pipe(take(1))
                .subscribe(data => {
                    if (data != null) {
                        // for change detection purpose
                        this.resourceUnedited = JSON.parse(JSON.stringify(data));
                        this.disableKeyControlEdit = this.resourceUnedited.isEditTriggered;
                        this.fillResourceObject(data);
                    } else {
                        let data: Resource = this.localStorage.load<Resource>(LocalDataKey.unSavedGeneric);
                        this.resourceUnedited = JSON.parse(JSON.stringify(data));
                        this.fillResourceObject(data);
                    }
                    this.initPageSectionReferences();
                });
        }

        // set resource type readonly
        if (this.resourceType && this.resourceTypes && this.genericTypePathName
            && this.genericTypePathName !== GenericTypePathname.GENERIC && this.pageType !== 'edit') {
            this.isResourceTypeReadOnly = true;
        }

        // save event subscription
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'SAVE').subscribe(e => {
            this.saveGenericProfile();
        });

    }

    fillResourceObject(data: Resource) {
        this.resource = data;
        this.localStorage.store(LocalDataKey.unSavedGeneric, this.resource);

        // data model initiation
        this.initDataModel();

        // set supplier
        if (this.resource.supplierId > 0) {
            this.validateSupplierWithCost(this.resource);
            this.assignedSupplierForResource = new SupplierSummary();
            this.assignedSupplierForResource.name = this.resource.supplierName;
            this.assignedSupplierForResource.supplierId = this.resource.supplierId;
            this.assignedSupplierForResource.code = this.resource.supplierCode;
            this.hasValidSupplier = true;
        }

        this.breakModel();
    }

    validateSupplierWithCost(resource: Resource) {
        let supplierSearchCriteria = new SupplierSearchCriteria();

        supplierSearchCriteria.status = 'true';
        supplierSearchCriteria.resourceTypes = [];
        supplierSearchCriteria.resourceTypes.push(this.resource.resourceType);
        this.supplierService.searchSuppliers(supplierSearchCriteria).subscribe(
            result => {
                let suppliers = ResponseUtil.getDataArray(result);
                if (suppliers && suppliers.length > 0) {
                    let supplierExist = suppliers.find(value => value.supplierId === resource.supplierId);
                    this.missingCostForSupplier = supplierExist ? false : true;
                } else {
                    this.missingCostForSupplier = true;
                }
            }, error => {
            }
        );
    }

    private setGenericType() {
        let page = this.activatedRoute.snapshot.queryParams['page'];
        this.genericTypePathName = page.split('_')[1];
        console.log(`Generic Type= ${this.genericTypePathName}`);

        this.resourceType = this.genericTypePathName;
    }

    private setResourceTypeByPathName() {
        if (this.genericTypePathName === GenericTypePathname.GUIDE) {
            this.resourceTypeObj = this.resourceTypes.find(value => value.code === 'guide');
        }
        if (this.genericTypePathName === GenericTypePathname.REP) {
            this.resourceTypeObj = this.resourceTypes.find(value => value.code === 'rep');
        }
        if (this.genericTypePathName === GenericTypePathname.MEAL) {
            this.resourceTypeObj = this.resourceTypes.find(value => value.code === 'meal');
        }
        if (this.genericTypePathName === GenericTypePathname.BELLY_DANCER) {
            this.resourceTypeObj = this.resourceTypes.find(value => value.code === 'bellydancer');
        }
        if (this.genericTypePathName === GenericTypePathname.TANOURA) {
            this.resourceTypeObj = this.resourceTypes.find(value => value.code === 'tanoura');
        }
        if (this.genericTypePathName === GenericTypePathname.HENNA_ARTIST) {
            this.resourceTypeObj = this.resourceTypes.find(value => value.code === 'hennaartist');
        }
        if (this.genericTypePathName === GenericTypePathname.TICKET) {
            this.resourceTypeObj = this.resourceTypes.find(value => value.code === 'ticket');
        }
        if (this.genericTypePathName === GenericTypePathname.DRIVER) {
            this.resourceTypeObj = this.resourceTypes.find(value => value.code === 'driver');
        }
        if (this.resourceTypeObj) {
            this.resourceType = this.resourceTypeObj.code;
            this.personalInfo.resourceType = this.resourceTypeObj.code;
        }
    }

    private initPageSectionReferences() {
        this.pageSectionsMap = this.cardDataHandlerService.getAllPageSections(
            this.CARD_CONFIG_GENERIC_EDIT,
            this.resource
        );

        this.personalInfoSection = this.pageSectionsMap.get('personal_info');
        this.keyControlSection = this.pageSectionsMap.get('key_controls');
        this.contactDetailsSection = this.pageSectionsMap.get('contact_details');
        this.specificFormSection = this.pageSectionsMap.get('specific_details');
        this.paymentInfoSection = this.pageSectionsMap.get('payment_details');
        this.additionalContactsSection = this.pageSectionsMap.get('additional_contacts');
        this.supplierAttributesSection = this.pageSectionsMap.get('supplier_attributes');
        this.notesSection = this.pageSectionsMap.get('notes');
        this.taxSchemeSection = this.pageSectionsMap.get('tax_schemes');

        this.setupHeader();
        this.filterPageSectionActions();
    }

    filterPageSectionActions() {
        if (this.resource && this.resource.resourceType !== ResourceType.vehicle) {
            this.taxSchemeSection.actions = this.taxSchemeSection.actions.filter(action => {
                return action !== 'TRIGGER_ADD_TAX_SCHEME';
            });
        }
    }

    public onHeaderActionClick(event) {
        switch (event.id) {
            case 'TRIGGER_ADD_ADDITIONAL_CONTACT': {
                console.log('add addition contact');
                this.additionalContactComponent.addAdditionalContact();
                break;
            }
            case 'TRIGGER_SET_SUPPLIER_ATTRIBUTES': {
                console.log('add supplier attribute');
                this.onSupplierAttributesClick();
                break;
            }
            case 'TRIGGER_ADD_NOTE': {
                console.log('add note');
                this.onAddNote();
                break;
            }
            case 'TRIGGER_ADD_TAX_SCHEME': {
                console.log('add tax scheme');
                if (this.resource && this.resource.resourceType !== ResourceType.vehicle) {
                    this.taxSchemeComponent.addTaxScheme();
                }
                break;
            }
        }
    }

    setupSectionTabError(section: PageSection): boolean {
        if (!section) {
            return false;
        }
        const shouldShow = section.showError === ERROR_LEVEL.SHOW_ERROR_TAB || section.showError ===
            ERROR_LEVEL.SHOW_ERROR_TAB_FORM;
        return section.error && shouldShow;
    }

    private setupHeader() {
        if (this.pageType === PageType.CREATE) {
            this.userJourneyManager.setCurrentHeading(this.headerTextNew);
        } else if (this.pageType === PageType.EDIT) {
            this.userJourneyManager.setCurrentHeading(this.headerTextEdit);
        }
        this.setHeaderActions();
        this.setHeaderActionTriggers();
        // this.setHeaderKebab();
    }

    private setHeaderActions() {
        let actionKeys = [];
        actionKeys.push('TRIGGER_CLOSE');
        this.userJourneyManager.setHeaderActions(actionKeys);
    }

    private removeHeaderActions() {
        this.userJourneyManager.setHeaderActions([]);
        this.em.removeEvents([
            'TRIGGER_CLOSE'
        ]);
    }

    private setHeaderActionTriggers() {
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'TRIGGER_CLOSE').subscribe(e => {
            this.onCloseClick(null);
        });
    }

    public onCloseClick(event) {
        this.location.back();
    }

    private breakModel() {
        if (this.resource && this.resource.genericResource) {
            this.copyToPersonalInfo();
        }
        if (this.resource && this.resource.contactDetails != null && this.resource.contactDetails.length > 0) {
            this.copyToContactDetails();
        }
        this.copyResourceSpecificInfo();
    }

    private initDataModel() {
        if (!this.resource) {
            this.resource = new Resource();
            this.resource.resourceType = this.genericTypePathName;
        }
        if (!this.personalInfo) {
            this.personalInfo = new PersonalInformation();
            this.personalInfo.activeStatus = true;
        }
        if (!this.resource.contactDetails) {
            this.resource.contactDetails = [];
        }
        if (!this.resource.documents) {
            this.resource.documents = [];
        }
        if (!this.resource.taxSchemes) {
            this.resource.taxSchemes = [];
        }
        if (!this.resource.genericResource) {
            this.resource.genericResource = new GenericResource();
        }
        if (!this.resource.paymentInfo) {
            this.resource.paymentInfo = new PaymentInfo();
        }
        if (!this.resource.supplierAttributes) {
            this.resource.supplierAttributes = [];
        }
        if (!this.resource.remarks) {
            this.resource.remarks = [];
        }
        if (!this.contactDetails) {
            this.contactDetails = new ContactDetails();
        }
        if (!this.additionalContactDetails) {
            this.additionalContactDetails = [];
        }
        if (!this.resourceSpecificData) {
            this.resourceSpecificData = new ResourceSpecificData();
        }
    }

    private retrieveMasterData() {
        this.dataHandlerService.retrieveTitleDetails().subscribe(
            result => {
                this.titles = result.data;
            });
        this.dataHandlerService.retrieveCategories().subscribe(
            result => {
                this.categories = result.data;
                this.defaultContactCategory = this.categories.find(value => value.name === 'Reservation');
            });
        this.dataHandlerService.retrieveCurrencyList().subscribe(
            result => {
                this.currencyList = result.data;
            });
        this.dataHandlerService.retrievePaymentMethods().subscribe(
            result => {
                this.payMethods = result.data;
            });
        this.dataHandlerService.retrieveTaxSchemes().subscribe(
            result => {
                this.taxSchemes = result.data;
            });

        this.dataHandlerService.retrieveResourceTypes().subscribe(
            result => {
                if (result.data) {
                    result.data.forEach(type => {
                        if (type['resourceCategory'] === this.RESOURCE_CATEGORY) {
                            this.resourceTypes.push(type);
                        }
                    });
                }
                this.setResourceTypeByPathName();
            });
        this.dataHandlerService.retrieveSupplierTypes().subscribe(
            result => {
                this.supplierTypes = result.data;
            }
        );
    }

    getSupplierAttributes() {
        this.dataStore.set(DataKey.supplierAttributes, null, true);
        this.attributesSubscription = this.dataStore.get(DataKey.supplierAttributes).subscribe(
            data => {
                if (data != null) {
                    this.resource.supplierAttributes = data;
                    this.dataChanged = true;
                    this.enableSaveButton();
                }
            });
    }

    public onSupplierAttributesClick() {
        this.dataStore.set(DataKey.modalClose, null);
        let dataObject = new ModalData(LEVEL.SUCCESS, 'Supplier Attributes',
            {'label': 'OK'},
            {'label': 'Close'},
            'supplier-attributes-modal',
            ManageSupplierAttributesWrapperComponent,
            {'supplierAttributes': this.resource.supplierAttributes}
        );
        this.confirmModal(dataObject);
        this.modalCloseSubscription = this.dataStore.get(DataKey.modalClose).subscribe((data) => {
            if (data != null) {
                this.modalCloseSubscription.unsubscribe();
                this.closeModal();
            }
        });

    }

    public onAddNote() {
        this.dataStore.set(DataKey.modalClose, null);
        let dataObject = new ModalData(LEVEL.SUCCESS, 'Add a note',

            null,
            null,
            'payment-modal',
            AddNoteComponent,
            {}
        );

        this.confirmModal(dataObject);

        this.modalCloseSubscription = this.dataStore.get(DataKey.modalClose).subscribe((data) => {
            if (data != null) {
                this.modalCloseSubscription.unsubscribe();
                this.closeModal();
            }
        });
    }

    closeModal() {
        if (this.modalService.close()) {
            this.modalService.close().subscribe(
                (res) => {
                }
            );
        }
    }

    private confirmModal(data: any): void {
        this.modalService.confirm(data).subscribe((res) => {
            console.log(res);
        });
    }

    // -----------change forms--------------------

    public onChangePersonalInfoForm($event: boolean) {
        this.personalInfoValid = $event;
        if (this.personalInfoSection) {
            this.personalInfoSection.error = !(this.personalInfoValid && this.hasValidSupplier);
        }
        this.dataChanged = true;
        this.enableSaveButton();
    }

    public onChangeKeyControlInfoForm(event) {
        this.keyControlInformationValid = event;
        this.enableSaveButton();
        if (this.keyControlSection) {
            this.keyControlSection.error = !this.keyControlInformationValid;
        }
    }

    public onChangePersonalContactForm(event) {
        this.personalContactValid = event;
        if (this.contactDetailsSection) {
            this.contactDetailsSection.error = !this.personalContactValid;
        }
        this.enableSaveButton();
    }

    public onAdditionalContactsModified() {
        this.additionalContactSummary = this.cardDataHandlerService.processCardData(
            this.CARD_CONFIG_ADDITIONAL_CONTACT,
            this.additionalContactDetails,
            'additional_contact_summary'
        );

        if (this.additionalContactDetails.length > 0) {
            this.additionalContactContents = [];
            this.additionalContactDetails.forEach(address => {
                let additionalContactContent = this.cardDataHandlerService.processCardData(
                    this.CARD_CONFIG_ADDITIONAL_CONTACT, address, 'additional_contact_detail');
                this.additionalContactContents.push(additionalContactContent);
            });
        }

        this.dataChanged = true;
        this.enableSaveButton();
    }

    public onChangePaymentForm($event: boolean) {
        this.supplierPaymentValid = $event;
        if (this.paymentInfoSection) {
            this.paymentInfoSection.error = !this.supplierPaymentValid;
        }
        this.enableSaveButton();
    }

    public onTaxSchemeModified() {
        this.taxSchemeSummary = this.cardDataHandlerService.processCardData(
            this.CARD_CONFIG_TAXSCHEME,
            this.resource.taxSchemes,
            'tax_scheme_summary'
        );

        if (this.resource.taxSchemes.length > 0) {
            this.taxSchemeContents = [];
            this.resource.taxSchemes.forEach(address => {
                let taxSchemeContent = this.cardDataHandlerService.processCardData(
                    this.CARD_CONFIG_TAXSCHEME, address, 'tax_scheme_detail');
                this.taxSchemeContents.push(taxSchemeContent);
            });
        }

        this.dataChanged = true;
        this.enableSaveButton();
    }

    public onChangeGuideSpecificForm($event: boolean) {
        this.guideValid = $event;
        this.specificDataValid = $event;
        if (this.specificFormSection) {
            this.specificFormSection.error = !this.specificDataValid;
        }
        this.enableSaveButton();
    }

    public onChangeDriverSpecificForm($event: boolean) {
        this.driverValid = $event;
        this.specificDataValid = $event;
        if (this.specificFormSection) {
            this.specificFormSection.error = !this.specificDataValid;
        }
        this.enableSaveButton();
    }

    public onChangeHennaArtistSpecificForm($event: boolean) {
        this.hennaArtistValid = $event;
        this.specificDataValid = $event;
        if (this.specificFormSection) {
            this.specificFormSection.error = !this.specificDataValid;
        }
        this.enableSaveButton();
    }

    public onSupplierTextChange($event: string) {
        if ($event !== '') {
            let supplierSearchCriteria = new SupplierSearchCriteria();
            supplierSearchCriteria.resourceTypes = [];
            supplierSearchCriteria.name = $event;
            supplierSearchCriteria.status = 'true';
            supplierSearchCriteria.kcCompany = this.resource.kcCompany;
            supplierSearchCriteria.kcDivision = this.resource.kcDivision;
            supplierSearchCriteria.kcBrand = this.resource.kcBrand;
            supplierSearchCriteria.kcDistributionChannel = this.resource.kcDistributionChannel;
            supplierSearchCriteria.resourceTypes.push(this.resource.resourceType);
            // supplierSearchCriteria.resourceCategory = ResourceCategory.GENERIC;
            // todo. check criteria

            this.supplierService.searchSuppliers(supplierSearchCriteria).subscribe(
                result => {
                    this.filteredSuppliers = ResponseUtil.getDataArray(result);
                }, error => {
                    this.filteredSuppliers = [];
                }
            );
        }
    }

    public onSupplierClear($event: any) {
        this.resource.supplierId = undefined;
        this.resource.supKcCompany = undefined;
        this.resource.supKcDivision = undefined;
        this.resource.supKcBrand = undefined;
        this.resource.supKcDistributionChannel = undefined;
        this.isResourceTypeReadOnly = false;
        this.hasValidSupplier = false;
    }

    public onSupplierAssign($event: SupplierSummary) {
        this.resource.supplierId = $event.supplierId;
        this.resource.supKcCompany = $event.kcCompany;
        this.resource.supKcDivision = $event.kcDivision;
        this.resource.supKcBrand = $event.kcBrand;
        this.resource.supKcDistributionChannel = $event.kcDistributionChannel;
        this.isResourceTypeReadOnly = true;
        this.hasValidSupplier = true;
        this.missingCostForSupplier = false;
    }

    public onUserTextChange($event: string) {
        if ($event !== '') {
            const userSearchCriteria = new UserProfileSearchCriteria();
            userSearchCriteria.name = $event;
            userSearchCriteria.resourceLinkSuggestion = true;
            userSearchCriteria.supplierId = this.resource.supplierId ? this.resource.supplierId : 0;
            userSearchCriteria.resourceSuggestIncludingId = this.resource.resourceId ? this.resource.resourceId : 0;
            userSearchCriteria.restrictedServiceTypes = [this.resource.resourceType];

            this.userProfileService.getProfilesWithoutKey(userSearchCriteria).subscribe(
                result => {
                    this.filteredUsers = ResponseUtil.getDataArray(result);
                }, error => {
                    this.filteredUsers = [];
                }
            );
        }
    }

    public onUserClear($event: any) {
        this.dataChanged = true;
        this.resource.userProfile = null;
        this.enableSaveButton();
    }

    public onUserAssign(event: UserProfile) {
        this.dataChanged = true;
        this.resource.userProfile = event;
        this.enableSaveButton();

    }

    public onNotesModified() {
        this.dataChanged = true;
        this.enableSaveButton();
    }

    public onAdditionalContactsValidChange($event: boolean) {
        this.additionalContactsValid = $event;
        if (this.additionalContactsSection) {
            this.additionalContactsSection.error = !this.additionalContactsValid;
        }
        this.enableSaveButton();
    }

    public onChangeTaxSchemeFormValidity() {
        this.dataChanged = true;
        this.enableSaveButton();
    }

    // private isValidSpecificData() {
    //     if (this.changeDetectSupporter.checkedSpecific) {
    //         this.specificDataValid = (this.driverValid || this.guideValid || this.repValid || this.mealValid || this.bellyDancerValid ||
    //             this.tanouraValid || this.hennaArtistValid || this.ticketValid);
    //         if (this.specificFormSection) {
    //             this.specificFormSection.error = !this.specificDataValid;
    //         }
    //         return this.specificDataValid;
    //     } else {
    //         this.specificFormSection.error = false;
    //         return true;
    //     }
    // }

    // -----------change forms--------------------//

    // save button
    private enableSaveButton() {
        console.log(this.checkSpecificData());
        this.updateDataChanged();
        if ((this.dataChanged && !this.formSaved)
            && this.supplierPaymentValid
            && this.personalInfoValid
            && this.personalContactValid
            && this.additionalContactsValid
            && this.checkSpecificData()
            && this.hasValidSupplier
        ) {
            this.userJourneyManager.canProceed.next(true);
            this.focusViewManager.canProceed.next(true);
            this.isSaveEnable = true;
            this.localStorage.store(LocalDataKey.unSavedGeneric, this.resource);
        } else {
            this.disableSaveButton();
        }
    }

    private checkSpecificData() {
        if (this.personalInfo &&
            (this.personalInfo.resourceType === 'guide' || this.personalInfo.resourceType === 'driver' ||
                this.personalInfo.resourceType === 'hennaartist')) {
            return this.specificDataValid;
        } else {
            return true;
        }
    }

    private disableSaveButton() {
        this.userJourneyManager.canProceed.next(false);
        this.focusViewManager.canProceed.next(false);
        this.isSaveEnable = false;
    }

    private updateDataChanged() {
        this.updateGenericProfile();

        // to make it same as resourceUnedited
        this.resource.contactDetails.forEach(value => {
            if (value.state === '') {
                value.state = null;
            }
        });

        if (JSON.stringify(this.resource) !== JSON.stringify(this.resourceUnedited)) {
            this.dataChanged = true;
            this.formSaved = false;
        } else {
            this.dataChanged = false;
        }
    }

    // save data
    private updateGenericProfile() {
        this.copyPersonalInfo();
        this.resource.contactDetails = [];
        this.resource.contactDetails.push(this.contactDetails);
        Array.prototype.push.apply(this.resource.contactDetails, this.additionalContactDetails);
    }

    private copyPersonalInfo() {
        this.resource.resourceType = this.personalInfo.resourceType;
        if (!this.resource.resourceType) {
            this.resource.resourceType = this.resourceType;
        }

        this.selectedResTypes = [{'code': this.resource.resourceType, 'name': this.resource.resourceType}];

        this.resource.genericResource.title = this.personalInfo.title;
        this.resource.genericResource.firstName = this.personalInfo.fName;
        this.resource.genericResource.lastName = this.personalInfo.lName;
        this.resource.genericResource.gender = this.personalInfo.gender;
        this.resource.genericResource.dateOfBirth = this.personalInfo.dateOfBirth;
        this.resource.activeStatus = this.personalInfo.activeStatus;
        this.resource.supplierType = this.personalInfo.supplierType;
        this.resource.businessType = this.personalInfo.businessType;
    }

    private copyToPersonalInfo() {
        this.personalInfo.resourceType = this.resource.resourceType;
        this.personalInfo.title = this.resource.genericResource.title;
        this.personalInfo.fName = this.resource.genericResource.firstName;
        this.personalInfo.lName = this.resource.genericResource.lastName;
        this.personalInfo.gender = this.resource.genericResource.gender;
        this.personalInfo.dateOfBirth = this.resource.genericResource.dateOfBirth;
        this.personalInfo.activeStatus = this.resource.activeStatus;
        this.personalInfo.supplierType = this.resource.supplierType;
        this.personalInfo.businessType = this.resource.businessType;
    }

    private copyToContactDetails() {
        if (this.resource && this.resource.contactDetails) {
            this.additionalContactDetails = [];
            this.resource.contactDetails.forEach(
                (contactDetails: ContactDetails) => {
                    if (contactDetails.status) {
                        this.contactDetails = contactDetails;
                    } else {
                        this.additionalContactDetails.push(contactDetails);
                    }
                });
        }
    }

    private copyResourceSpecificInfo() {

    }

    private saveGenericProfile() {
        this.updateGenericProfile();
        console.log(this.resource);
        if (this.pageType === PageType.CREATE || !this.resource.resourceId) {
            //this.createResourceObserver();
            this.spinnerService.show();
            if ((this.resource.supKcCompany === this.resource.kcCompany) &&
                ((!this.resource.supKcDivision || !this.resource.kcDivision ||
                        (this.resource.supKcDivision === this.resource.kcDivision)) &&
                    (!this.resource.supKcBrand || !this.resource.kcBrand ||
                        (this.resource.supKcBrand === this.resource.kcBrand)) &&
                    (!this.resource.supKcDistributionChannel || !this.resource.kcDistributionChannel ||
                        (this.resource.supKcDistributionChannel === this.resource.kcDistributionChannel)))) {
                this.profileManagementService.saveResource(this.resource)
                    .subscribe(value => {
                        if (this.commonHelper.dataValidity(value)) {
                            this.createResourceObsv.unsubscribe();
                            this.spinnerService.hide();
                            if (ResponseUtil.isSuccess(value)) {
                                this.formSaved = true;
                                this.dataChanged = false;
                                this.resourceUnedited = JSON.parse(JSON.stringify(this.resource));
                                this.localStorage.delete(LocalDataKey.unSavedGeneric);
                                this.common.showSnackBar(
                                    'Successfully saved the generic profile.',
                                    3000,
                                    TcErrorType.TYPE.INFO
                                );
                                this.handleNavigation(value);
                            } else if (ResponseUtil.isError(value)) {
                                this.common.showSnackBar(
                                    'Failed to save the generic profile',
                                    3000,
                                    TcErrorType.TYPE.ERROR
                                );
                            }
                        } else if (value instanceof TcApiError) {
                            this.spinnerService.hide();
                        } else if (value instanceof TcHttpError) {
                            this.spinnerService.hide();
                        }
                    }, error => {
                    });
            }
        } else if (this.pageType === PageType.EDIT && this.resource.resourceId) {
            this.dataStore.set(DataKey.updateResource, null, true);
            //this.updateResourceObserver();
            this.spinnerService.show();
            if ((this.resource.supKcCompany === this.resource.kcCompany) &&
                ((!this.resource.supKcDivision || !this.resource.kcDivision ||
                        (this.resource.supKcDivision === this.resource.kcDivision)) &&
                    (!this.resource.supKcBrand || !this.resource.kcBrand ||
                        (this.resource.supKcBrand === this.resource.kcBrand)) &&
                    (!this.resource.supKcDistributionChannel || !this.resource.kcDistributionChannel ||
                        (this.resource.supKcDistributionChannel === this.resource.kcDistributionChannel)))) {
                this.profileManagementService.updateResource(this.resource, String(this.resource.resourceId))
                    .subscribe(value => {
                        if (this.commonHelper.dataValidity(value)) {
                            this.createResourceObsv.unsubscribe();
                            this.dataStore.set(DataKey.updateResource, null, true);
                            this.spinnerService.hide();
                            if (ResponseUtil.isSuccess(value)) {
                                this.formSaved = true;
                                this.dataChanged = false;
                                this.resourceUnedited = JSON.parse(JSON.stringify(this.resource));
                                this.common.showSnackBar(
                                    'Successfully updated the generic profile',
                                    3000,
                                    TcErrorType.TYPE.INFO
                                );
                                this.localStorage.delete(LocalDataKey.unSavedGeneric);
                                this.handleNavigation(value);
                            } else if (ResponseUtil.isError(value)) {
                                this.common.showSnackBar(
                                    'Failed to update the generic profile',
                                    3000,
                                    TcErrorType.TYPE.ERROR
                                );
                            }
                        } else if (value instanceof TcApiError) {
                            this.spinnerService.hide();
                        } else if (value instanceof TcHttpError) {
                            this.spinnerService.hide();
                        }
                    }, error => {
                    });
            }
        }
    }

    private confirmDialog(dialog: any) {
        this.dialogService.confirm(dialog);
    }

    // country state city
    public onNewCountryStateCityObserver($event: InitialCountryStateCityCodes) {
        let wrapper = new CountryStateCityWrapper();
        this.countryStateCityChangeMap.set($event.id, wrapper);

        this.countryStateCityService.getInitialCity($event.countryCode, $event.stateCode, $event.cityCode)
            .then((value: City) => {
                if (value) {
                    wrapper.city = value;
                    this.changeDetectorService.notifyCountryStateCityChange();
                }
            });

        this.countryStateCityService.getInitialState($event.countryCode, $event.stateCode)
            .then((value: State) => {
                if (value) {
                    wrapper.state = value;
                    this.changeDetectorService.notifyCountryStateCityChange();
                }
            });

        this.countryStateCityService.getInitialCountry($event.countryCode)
            .then((value: Country) => {
                if (value) {
                    wrapper.country = value;
                    this.changeDetectorService.notifyCountryStateCityChange();
                }
            });
    }

    public onSelectCountry($event: CountryChange) {
        let wrapper = this.countryStateCityChangeMap.get($event.id);
        this.countryStateCityService.onSelectCountry($event.country, wrapper);
        this.changeDetectorService.notifyCountryStateCityChange();
    }

    public onSelectState($event: StateChange) {
        let wrapper = this.countryStateCityChangeMap.get($event.id);
        this.countryStateCityService.onSelectState($event.state, wrapper);
        this.changeDetectorService.notifyCountryStateCityChange();
    }

    public onSelectCity($event: CityChange) {
        let wrapper = this.countryStateCityChangeMap.get($event.id);
        this.countryStateCityService.onSelectCity($event.city, wrapper);
        this.changeDetectorService.notifyCountryStateCityChange();
    }

    public onCountryTextChange($event: CountryChange) {
        this.countryStateCityService.onCountryTextChange($event.text);
    }

    public onStateTextChange($event: StateChange) {
        let wrapper = this.countryStateCityChangeMap.get($event.id);
        this.countryStateCityService.onStateTextChange($event.text, wrapper);
    }

    public onCityTextChange($event: CityChange) {
        let wrapper = this.countryStateCityChangeMap.get($event.id);
        this.countryStateCityService.onCityTextChange($event.text, wrapper);
    }

    private subscribeCountryStateCityListChange() {
        this.countryStateCityService.countryListObserver.subscribe(
            value => {
                this.countryList = value;
            }
        );

        this.countryStateCityService.stateListObserver.subscribe(
            value => {
                this.stateList = value;
            }
        );

        this.countryStateCityService.cityListObserver.subscribe(
            value => {
                this.cityList = value;
            }
        );
    }

    handleNavigation(data: any) {
        if (data && JSON.stringify(data) !== JSON.stringify({})) {
            if (data.status.code === TC.ErrorCodes.SUCCESS) {

                // if the client is trade client
                if (data && data.data && data.data.length > 0 && data.data[0].resourceId) {
                    const genericSearchCriteria: GenericSearchCriteria = new GenericSearchCriteria();
                    genericSearchCriteria.resourceType = data.data[0].resourceType;
                    genericSearchCriteria.activeStatus = data.data[0].activeStatus;
                    genericSearchCriteria.resourceId = data.data[0].resourceId;
                    console.log(genericSearchCriteria);
                    let parameters = this.queryParamService.getNotNullQueryParamsArray(genericSearchCriteria);
                    this.rootService.setDataToLocalStorage(
                        TCO.AppData.GENERIC_SEARCH_CRITERIA,
                        genericSearchCriteria,
                        true,
                        parameters
                    );
                }

                setTimeout(() => {

                    let journeyToProceed = 'BEGIN_RESOURCE_MANAGEMENT_AS_GENERIC';
                    if (journeyToProceed) {
                        this.userJourneyManager.goForKey(journeyToProceed);
                    }

                }, 100);
            } else {
                if (data.status.code === TC.ErrorCodes.ERROR && data.error) {
                }
            }
        }
    }

    // --country state city--//

    private getUserDetails() {
        this.userProfile = this.dataStore.get(DataKey.userProfile).getValue();
    }

    ngOnDestroy(): void {
        this.removeHeaderActions();
        this.localStorage.delete(LocalDataKey.unSavedGeneric);
    }

    public ngAfterViewInit(): void {
        let element = document.querySelector('.main-panel');
        if (element) {
            element.scrollTop = 0;
        }
    }

    public onResourceTypeChange($event: string) {
        if (this.specificFormSection) {
            this.specificFormSection.error = false;
        }
    }
}
